import { useGetMany } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import type { Company, Contact } from "../types";
import { useAgentActivity } from "./useAgentActivity";
import { AgentActivityCard } from "./AgentActivityCard";

/**
 * Mobile equivalent of AgentActivityList.tsx's desktop table — same
 * MobileHeader/MobileContent + card-list shape as ApprovalQueueListMobile.tsx.
 */
export const AgentActivityListMobile = () => {
  const { data: runs, isPending, isError } = useAgentActivity();

  const contactIds = [
    ...new Set(
      (runs ?? [])
        .map((r) => r.target_contact_id)
        .filter((id): id is number => id != null),
    ),
  ];
  const companyIds = [
    ...new Set(
      (runs ?? [])
        .map((r) => r.target_company_id)
        .filter((id): id is number => id != null),
    ),
  ];

  const { data: contacts } = useGetMany<Contact>(
    "contacts",
    { ids: contactIds },
    { enabled: contactIds.length > 0 },
  );
  const { data: companies } = useGetMany<Company>(
    "companies",
    { ids: companyIds },
    { enabled: companyIds.length > 0 },
  );

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">Agent Activity</h1>
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col gap-3">
          {isPending && (
            <p className="text-muted-foreground text-sm">Loading…</p>
          )}
          {isError && (
            <p className="text-muted-foreground text-sm italic">
              Couldn't load agent activity.
            </p>
          )}
          {!isPending && !isError && runs?.length === 0 && (
            <p className="text-muted-foreground text-sm italic">
              No targeted agent activity yet.
            </p>
          )}
          {runs?.map((run) => (
            <AgentActivityCard
              key={run.id}
              run={run}
              contacts={contacts}
              companies={companies}
            />
          ))}
        </div>
      </MobileContent>
    </>
  );
};
